














































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { apiBase, apiNamespace } from '@/config';
import AbstractTable from '@/components/admin/AbstractTable.vue';
import {
  ApplicationRecord,
  Booking,
  Customer,
  Vehicle,
  Discount,
  ContactSubmission,
  Lot,
  Airline,
  Flight,
  BusTrip,
  VehicleType,
  Extra,
  ShortTermDay,
  ExceptionalDay,
  BlockoutPeriod,
} from '@/api';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import BookingFilters from '@/components/admin/BookingFilters.vue';
import CustomerFilters from '@/components/admin/CustomerFilters.vue';
import VehicleFilters from '@/components/admin/VehicleFilters.vue';
import LongRatesEdit from '@/components/admin/LongRatesEdit.vue';
import { Scope } from 'spraypaint';
import { authModule } from '@/store';

@Component({
  components: {
    AbstractTable,
    ConfirmDialog,
    BookingFilters,
    CustomerFilters,
    VehicleFilters,
    LongRatesEdit,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  singleSelect: boolean = true;
  selected: ApplicationRecord[] = [];

  itemDeleteDialog: boolean = false;
  confirmDeleteMessage: string = '';

  ratesHeaders: any = null;
  daysHeaders: any = null;

  bookingScope: () => Scope<Booking> = Booking.scopeFactory;
  customerScope: () => Scope<Customer> = Customer.scopeFactory;
  vehicleScope: () => Scope<Vehicle> = Vehicle.scopeFactory;

  get model() {
    switch (this.$route.name) {
      case 'admin-bookings':
        return Booking;
      case 'admin-customers':
        return Customer;
      case 'admin-vehicles':
        return Vehicle;
      case 'admin-discounts':
        return Discount;
      case 'admin-contact':
        return ContactSubmission;
      case 'admin-lots':
        return Lot;
      case 'admin-airlines':
        return Airline;
      case 'admin-flights':
        return Flight;
      case 'admin-bustrips':
        return BusTrip;
      case 'admin-vehicletypes':
        return VehicleType;
      case 'admin-extras':
        return Extra;
      case 'admin-rates':
        return ShortTermDay;
      case 'admin-days':
        return ExceptionalDay;
      case 'admin-blockout-periods':
        return BlockoutPeriod
      default:
        return ApplicationRecord;
    }
  }

  get headers() {
    switch (this.$route.name) {
      case 'admin-rates':
        return this.ratesHeaders;
      case 'admin-days':
        return this.daysHeaders;
      default:
        return this.model.listHeaders();
    }
  }

  get scopeFactory() {
    switch (this.$route.name) {
      case 'admin-bookings':
        return this.bookingScope;
      case 'admin-customers':
        return this.customerScope;
      case 'admin-vehicles':
        return this.vehicleScope;
      default:
        return this.model.scopeFactory;
    }
  }

  get defaultOptions() {
    return this.model.defaultOptions();
  }

  get bookingActions() {
    return [
      {
        text: 'Add a Booking',
        icon: 'far fa-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-bookings-add' });
        },
        showMe: () => this.$route.name === 'admin-bookings',
      },
      {
        text: 'Edit Booking',
        icon: 'far fa-file-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-bookings-edit',
              params: { bookingId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-bookings',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Booking',
        icon: 'far fa-trash',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this booking?';
          this.itemDeleteDialog = true;
        },
        showMe: () =>
          authModule.isAdmin && this.$route.name === 'admin-bookings',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Check In',
        icon: 'far fa-clipboard-list-check',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-bookings-checkin',
              params: { bookingId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-bookings',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'View Invoice',
        icon: 'far fa-file-invoice',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            window.open(
              apiBase +
              apiNamespace +
              '/bookings/' +
              this.singleSelected.id +
              '/invoice/',
              '_blank',
            );
          }
        },
        showMe: () => this.$route.name === 'admin-bookings',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'View Parked Cars',
        icon: 'far fa-car',
        onClick: () => {
          window.open(
            apiBase + apiNamespace + '/currently-parked-cars/',
            '_blank',
          );
        },
        showMe: () => this.$route.name === 'admin-bookings',
      },
      {
        text: 'View Income Owed',
        icon: 'far fa-credit-card',
        onClick: () => {
          window.open(apiBase + apiNamespace + '/total-tba-owed/', '_blank');
        },
        showMe: () => this.$route.name === 'admin-bookings',
      },
      {
        text: 'Export Bookings',
        icon: 'far fa-file-export',
        onClick: () => {
          const queryParams = this.bookingScope().toQueryParams() || '';
          window.open(
            apiBase + apiNamespace + `/bookings/csv/?${queryParams}`,
            '_blank',
          );
        },
        showMe: () => this.$route.name === 'admin-bookings',
        isDisabled: !this.bookingScope().toQueryParams(),
      },
    ];
  }
  get customerActions() {
    return [
      {
        text: 'Add a Customer',
        icon: 'far fa-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-customers-add' });
        },
        showMe: () => this.$route.name === 'admin-customers',
      },
      {
        text: 'Edit Customer',
        icon: 'far fa-file-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-customers-edit',
              params: { customerId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-customers',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Export Customers',
        icon: 'far fa-file-export',
        onClick: () => {
          const queryParams = this.customerScope().toQueryParams() || '';
          window.open(
            apiBase + apiNamespace + `/customers/csv/?${queryParams}`,
            '_blank',
          );
        },
        showMe: () => this.$route.name === 'admin-customers',
        isDisabled: !this.customerScope().toQueryParams(),
      },
    ];
  }
  get vehicleActions() {
    return [
      {
        text: 'Edit Vehicle',
        icon: 'far fa-file-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-vehicles-edit',
              params: { vehicleId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-vehicles',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Vehicle',
        icon: 'far fa-trash',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this vehicle?';
          this.itemDeleteDialog = true;
        },
        showMe: () =>
          authModule.isAdmin && this.$route.name === 'admin-vehicles',
        isDisabled: this.selected.length === 0,
      },
    ];
  }
  get discountActions() {
    return [
      {
        text: 'Add a Discount',
        icon: 'far fa-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-discounts-add' });
        },
        showMe: () => this.$route.name === 'admin-discounts',
      },
      {
        text: 'Edit Discount',
        icon: 'far fa-file-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-discounts-edit',
              params: { discountId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-discounts',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Discount',
        icon: 'far fa-trash',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this discount?';
          this.itemDeleteDialog = true;
        },
        showMe: () =>
          authModule.isAdmin && this.$route.name === 'admin-discounts',
        isDisabled: this.selected.length === 0,
      },
    ];
  }
  get contactActions() {
    return [
      {
        text: 'View Message',
        icon: 'far fa-eye',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-contact-view',
              params: { messageId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-contact',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Message',
        icon: 'far fa-trash',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this message?';
          this.itemDeleteDialog = true;
        },
        showMe: () =>
          authModule.isAdmin && this.$route.name === 'admin-contact',
        isDisabled: this.selected.length === 0,
      },
    ];
  }
  get lotActions() {
    return [
      {
        text: 'Add a Lot',
        icon: 'far fa-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-lots-add' });
        },
        showMe: () => this.$route.name === 'admin-lots',
      },
      {
        text: 'Edit Lot',
        icon: 'far fa-file-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-lots-edit',
              params: { lotId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-lots',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Lot',
        icon: 'far fa-trash',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this lot?';
          this.itemDeleteDialog = true;
        },
        showMe: () => this.$route.name === 'admin-lots',
        isDisabled: this.selected.length === 0,
      },
    ];
  }
  get airlineActions() {
    return [
      {
        text: 'Add an Airline',
        icon: 'far fa-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-airlines-add' });
        },
        showMe: () => this.$route.name === 'admin-airlines',
      },
      {
        text: 'Edit Airline',
        icon: 'far fa-file-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-airlines-edit',
              params: { airlineId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-airlines',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Airline',
        icon: 'far fa-trash',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this airline?';
          this.itemDeleteDialog = true;
        },
        showMe: () => this.$route.name === 'admin-airlines',
        isDisabled: this.selected.length === 0,
      },
    ];
  }
  get flightActions() {
    return [
      {
        text: 'Add a Flight',
        icon: 'far fa-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-flights-add' });
        },
        showMe: () => this.$route.name === 'admin-flights',
      },
      {
        text: 'Edit Flight',
        icon: 'far fa-file-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-flights-edit',
              params: { flightId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-flights',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Flight',
        icon: 'far fa-trash',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this flight?';
          this.itemDeleteDialog = true;
        },
        showMe: () => this.$route.name === 'admin-flights',
        isDisabled: this.selected.length === 0,
      },
    ];
  }
  get busTripActions() {
    return [
      {
        text: 'Add a Bus Trip',
        icon: 'far fa-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-bustrips-add' });
        },
        showMe: () => this.$route.name === 'admin-bustrips',
      },
      {
        text: 'Edit Bus Trip',
        icon: 'far fa-file-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-bustrips-edit',
              params: { busTripId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-bustrips',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Bus Trip',
        icon: 'far fa-trash',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this bus trip?';
          this.itemDeleteDialog = true;
        },
        showMe: () => this.$route.name === 'admin-bustrips',
        isDisabled: this.selected.length === 0,
      },
    ];
  }
  get vehicleTypeActions() {
    return [
      {
        text: 'Add a Vehicle Type',
        icon: 'far fa-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-vehicletypes-add' });
        },
        showMe: () => this.$route.name === 'admin-vehicletypes',
      },
      {
        text: 'Edit Vehicle Type',
        icon: 'far fa-file-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-vehicletypes-edit',
              params: { vehicleTypeId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-vehicletypes',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Vehicle Type',
        icon: 'far fa-trash',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this vehicle type?';
          this.itemDeleteDialog = true;
        },
        showMe: () => this.$route.name === 'admin-vehicletypes',
        isDisabled: this.selected.length === 0,
      },
    ];
  }
  get extraActions() {
    return [
      {
        text: 'Add an Extra',
        icon: 'far fa-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-extras-add' });
        },
        showMe: () => this.$route.name === 'admin-extras',
      },
      {
        text: 'Edit Extra',
        icon: 'far fa-file-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-extras-edit',
              params: { extraId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-extras',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Extra',
        icon: 'far fa-trash',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this extra?';
          this.itemDeleteDialog = true;
        },
        showMe: () => this.$route.name === 'admin-extras',
        isDisabled: this.selected.length === 0,
      },
    ];
  }
  get rateActions() {
    return [
      {
        text: 'Add a Rate',
        icon: 'far fa-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-rates-add' });
        },
        showMe: () => this.$route.name === 'admin-rates',
      },
      {
        text: 'Edit Rate',
        icon: 'far fa-file-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-rates-edit',
              params: { rateId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-rates',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Rate',
        icon: 'far fa-trash',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this rate?';
          this.itemDeleteDialog = true;
        },
        showMe: () => this.$route.name === 'admin-rates',
        isDisabled: this.selected.length === 0,
      },
    ];
  }
  get dayActions() {
    return [
      {
        text: 'Add a Day',
        icon: 'far fa-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-days-add' });
        },
        showMe: () => this.$route.name === 'admin-days',
      },
      {
        text: 'Edit Day',
        icon: 'far fa-file-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-days-edit',
              params: { dayId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-days',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Day',
        icon: 'far fa-trash',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this day?';
          this.itemDeleteDialog = true;
        },
        showMe: () => this.$route.name === 'admin-days',
        isDisabled: this.selected.length === 0,
      },
    ];
  }

  get blockoutPeriodActions() {
    return [
      {
        text: 'Add Blockout Period',
        icon: 'far fa-plus',
        onClick: () => {
          this.$router.push({ name: 'admin-blockout-periods-add' });
        },
        showMe: () => this.$route.name === 'admin-blockout-periods',
      },
      {
        text: 'Edit Blockout Period',
        icon: 'far fa-file-edit',
        onClick: () => {
          if (this.singleSelected && this.singleSelected.id) {
            this.$router.push({
              name: 'admin-blockout-periods-edit',
              params: { blockoutPeriodId: this.singleSelected.id },
            });
          }
        },
        showMe: () => this.$route.name === 'admin-blockout-periods',
        isDisabled: this.selected.length === 0,
      },
      {
        text: 'Delete Blockout Period',
        icon: 'far fa-trash',
        onClick: () => {
          this.confirmDeleteMessage =
            'Are you sure you would like to delete this blockout period?';
          this.itemDeleteDialog = true;
        },
        showMe: () => this.$route.name === 'admin-blockout-periods',
        isDisabled: this.selected.length === 0,
      },
    ]
  }

  get actions() {
    const actions: any[] = [];
    return actions.concat(
      this.bookingActions,
      this.customerActions,
      this.vehicleActions,
      this.discountActions,
      this.contactActions,
      this.lotActions,
      this.airlineActions,
      this.flightActions,
      this.busTripActions,
      this.vehicleTypeActions,
      this.extraActions,
      this.rateActions,
      this.dayActions,
      this.blockoutPeriodActions,
    );
  }

  get filteredActions() {
    return this.actions.filter(action => action.showMe());
  }

  get singleSelected() {
    return this.selected[0] || null;
  }

  get filtersComponent() {
    switch (this.$route.name) {
      case 'admin-bookings':
        return BookingFilters;
      case 'admin-customers':
        return CustomerFilters;
      case 'admin-vehicles':
        return VehicleFilters;
      default:
        return null;
    }
  }

  get optionsComponent() {
    switch (this.$route.name) {
      case 'admin-rates':
        return LongRatesEdit;
      default:
        return null;
    }
  }

  itemClicked(item: ApplicationRecord) {
    if (!item.id) {
      return;
    }
    if (this.$route.name === 'admin-bookings') {
      this.$router.push({
        name: 'admin-bookings-edit',
        params: { bookingId: item.id },
      });
    } else if (this.$route.name === 'admin-customers') {
      this.$router.push({
        name: 'admin-customers-edit',
        params: { customerId: item.id },
      });
    } else if (this.$route.name === 'admin-vehicles') {
      this.$router.push({
        name: 'admin-vehicles-edit',
        params: { vehicleId: item.id },
      });
    } else if (this.$route.name === 'admin-discounts') {
      this.$router.push({
        name: 'admin-discounts-edit',
        params: { discountId: item.id },
      });
    } else if (this.$route.name === 'admin-contact') {
      this.$router.push({
        name: 'admin-contact-view',
        params: { discountId: item.id },
      });
    } else if (this.$route.name === 'admin-lots') {
      this.$router.push({
        name: 'admin-lots-edit',
        params: { lotId: item.id },
      });
    } else if (this.$route.name === 'admin-airlines') {
      this.$router.push({
        name: 'admin-airlines-edit',
        params: { airlineId: item.id },
      });
    } else if (this.$route.name === 'admin-flights') {
      this.$router.push({
        name: 'admin-flights-edit',
        params: { flightId: item.id },
      });
    } else if (this.$route.name === 'admin-bustrips') {
      this.$router.push({
        name: 'admin-bustrips-edit',
        params: { busTripId: item.id },
      });
    } else if (this.$route.name === 'admin-vehicletypes') {
      this.$router.push({
        name: 'admin-vehicletypes-edit',
        params: { vehicleTypeId: item.id },
      });
    } else if (this.$route.name === 'admin-extras') {
      this.$router.push({
        name: 'admin-extras-edit',
        params: { extraId: item.id },
      });
    } else if (this.$route.name === 'admin-rates') {
      this.$router.push({
        name: 'admin-rates-edit',
        params: { rateId: item.id },
      });
    } else if (this.$route.name === 'admin-days') {
      this.$router.push({
        name: 'admin-days-edit',
        params: { dayId: item.id },
      });
    } else if (this.$route.name == 'admin-blockout-periods') {
      this.$router.push({
        name: 'admin-blockout-periods-edit',
        params: { blockoutPeriodId: item.id }
      });
    }
  }

  doFilter(filters: any) {
    const filtersClone = { ...filters };
    switch (this.$route.name) {
      case 'admin-bookings':
        this.bookingScope = () =>
          Booking.scopeFactory().where({
            id: filtersClone.id,
            customer_details: filtersClone.customer,
            rego: filtersClone.rego,
            end_datetime__gte_or_isnull: filtersClone.dateFrom,
            start_datetime__lte: filtersClone.dateTo,
            status: filtersClone.status,
            paymentStatus: filtersClone.paymentStatus,
            currently_parked: filtersClone.parked,
          });
        break;
      case 'admin-customers':
        this.customerScope = () =>
          Customer.scopeFactory().where({
            search: filtersClone.search,
            userRoles: filtersClone.roles,
          });
        break;
      case 'admin-vehicles':
        this.vehicleScope = () =>
          Vehicle.scopeFactory().where({
            rego: filtersClone.rego,
          });
        break;
    }
    (this.$refs.abstractTable as AbstractTable).options.page = 1;
    setTimeout(this.update, 300);
  }

  update() {
    (this.$refs.abstractTable as AbstractTable).update();
  }

  async deleteSelectedItem() {
    if (!this.singleSelected) {
      return;
    }
    switch (this.$route.name) {
      case 'admin-vehicles':
        try {
          (this.singleSelected as Vehicle).deleted = true;
          await this.singleSelected.save();
        } catch (err) {
          // Error
        } finally {
          this.itemDeleteDialog = false;
          this.selected = [];
          this.update();
        }
      default:
        try {
          await this.singleSelected.destroy();
        } catch (err) {
          // Error
        } finally {
          this.itemDeleteDialog = false;
          this.selected = [];
          this.update();
        }
    }
  }

  async mounted() {
    try {
      this.ratesHeaders = await ShortTermDay.listHeaders();
      this.daysHeaders = await ExceptionalDay.listHeaders();
    } catch (err) {
      // Error
    }
  }
}
